module.exports = __webpack_public_path__ + "static/logo-chitf-australia-2x-da499c1bd7d8c8a500cea3070b1fd850.png";